import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner, Modal } from 'react-bootstrap';
import { getRetailerRiders, deleteRetailerRider } from '../../actions/ridersAction';
import { getUserFromLocalStorage } from 'utilities/user';
import RetailerRiderForm from '../../views/Forms/RetailerRiderForm.js';
import {
  TwoWheeler,
  DirectionsBike,
  DirectionsCar,
  AirportShuttle,
  LocalShipping,
  DirectionsWalk,
  Add,
  Edit,
  Delete,
  SignalWifi4Bar,
  SignalWifiOff,
  DirectionsBus,
  Schedule,
} from '@material-ui/icons';
import io from 'socket.io-client';

/* ─── Status helpers ─────────────────────────────────────────────────── */
const STATUS_CONFIG = {
  Online:    { color: '#16a34a', bg: '#dcfce7', label: 'Online' },
  Offline:   { color: '#dc2626', bg: '#fee2e2', label: 'Offline' },
  Busy:      { color: '#d97706', bg: '#fef3c7', label: 'Busy' },
  inTransit: { color: '#2563eb', bg: '#dbeafe', label: 'In Transit' },
};
const getStatusCfg = (s) => STATUS_CONFIG[s] || { color: '#6b7280', bg: '#f3f4f6', label: 'Unknown' };

const CARRIER_ICON = {
  Motorcycle: TwoWheeler,
  Bicycle:    DirectionsBike,
  Car:        DirectionsCar,
  Van:        AirportShuttle,
  Truck:      LocalShipping,
  Walking:    DirectionsWalk,
};

/* ─── Inline styles ──────────────────────────────────────────────────── */
const S = {
  page: {
    padding: '28px 24px',
    background: '#f8fafc',
    minHeight: '100vh',
  },
  pageHeader: {
    background: 'linear-gradient(135deg, #005370 0%, #0291a1 100%)',
    borderRadius: '16px',
    padding: '22px 28px',
    marginBottom: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0 8px 32px rgba(0,83,112,0.18)',
  },
  pageTitle: {
    color: '#fff',
    fontWeight: 700,
    fontSize: '1.25rem',
    margin: 0,
    letterSpacing: '-0.01em',
  },
  pageSubtitle: {
    color: 'rgba(255,255,255,0.75)',
    fontSize: '0.82rem',
    marginTop: '3px',
  },
  addBtn: {
    background: 'rgba(255,255,255,0.18)',
    border: '1.5px solid rgba(255,255,255,0.45)',
    borderRadius: '10px',
    color: '#fff',
    fontWeight: 700,
    fontSize: '0.88rem',
    padding: '9px 20px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
    transition: 'background 0.2s',
    backdropFilter: 'blur(4px)',
  },
  statsRow: {
    display: 'flex',
    gap: '12px',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },
  statCard: (color, bg) => ({
    background: bg,
    border: `1.5px solid ${color}33`,
    borderRadius: '12px',
    padding: '12px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    minWidth: '130px',
  }),
  statDot: (color) => ({
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    background: color,
    flexShrink: 0,
  }),
  statLabel: {
    fontSize: '0.82rem',
    fontWeight: 600,
    color: '#374151',
  },
  statValue: {
    fontSize: '1.1rem',
    fontWeight: 700,
    color: '#111827',
    lineHeight: 1,
  },
  tableCard: {
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
    overflow: 'hidden',
  },
  tableHeader: {
    display: 'grid',
    gridTemplateColumns: '40px 1fr 130px 180px 120px 120px 160px',
    padding: '11px 20px',
    background: '#f1f5f9',
    borderBottom: '1px solid #e2e8f0',
  },
  tableHeaderCell: {
    fontSize: '0.72rem',
    fontWeight: 700,
    color: '#6b7280',
    textTransform: 'uppercase',
    letterSpacing: '0.07em',
  },
  tableRow: (even) => ({
    display: 'grid',
    gridTemplateColumns: '40px 1fr 130px 180px 120px 120px 160px',
    padding: '14px 20px',
    borderBottom: '1px solid #f1f5f9',
    background: even ? '#fafafa' : '#fff',
    alignItems: 'center',
    transition: 'background 0.15s',
  }),
  cell: {
    fontSize: '0.875rem',
    color: '#374151',
  },
  indexCell: {
    fontSize: '0.8rem',
    color: '#9ca3af',
    fontWeight: 600,
  },
  nameCell: {
    fontWeight: 600,
    color: '#111827',
    fontSize: '0.9rem',
  },
  carrierBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    background: '#f0f9ff',
    border: '1px solid #bae6fd',
    borderRadius: '20px',
    padding: '3px 11px',
    fontSize: '0.8rem',
    color: '#0369a1',
    fontWeight: 600,
  },
  statusBadge: (color, bg) => ({
    display: 'inline-block',
    background: bg,
    color: color,
    borderRadius: '20px',
    padding: '3px 12px',
    fontSize: '0.78rem',
    fontWeight: 700,
  }),
  actionCell: {
    display: 'flex',
    gap: '8px',
  },
  btnEdit: {
    padding: '6px 14px',
    borderRadius: '8px',
    border: '1.5px solid #0291a1',
    background: '#fff',
    color: '#0291a1',
    fontWeight: 600,
    fontSize: '0.8rem',
    cursor: 'pointer',
    transition: 'all 0.15s',
  },
  btnDelete: {
    padding: '6px 14px',
    borderRadius: '8px',
    border: '1.5px solid #fca5a5',
    background: '#fff',
    color: '#dc2626',
    fontWeight: 600,
    fontSize: '0.8rem',
    cursor: 'pointer',
    transition: 'all 0.15s',
  },
  emptyState: {
    padding: '60px 24px',
    textAlign: 'center',
  },
  emptyIcon: {
    fontSize: '3rem',
    marginBottom: '12px',
  },
  emptyTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    color: '#374151',
    marginBottom: '6px',
  },
  emptyText: {
    fontSize: '0.875rem',
    color: '#9ca3af',
    maxWidth: '360px',
    margin: '0 auto',
  },
  /* Delete confirm modal */
  deleteModalContent: {
    borderRadius: '14px',
    border: 'none',
    overflow: 'hidden',
    boxShadow: '0 24px 64px rgba(0,0,0,0.18)',
  },
  deleteModalHeader: {
    background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
    borderBottom: 'none',
    padding: '18px 22px',
  },
  deleteModalTitle: {
    color: '#fff',
    fontWeight: 700,
    fontSize: '1rem',
  },
  deleteModalBody: {
    padding: '22px 22px 8px',
    fontSize: '0.9rem',
    color: '#374151',
  },
  deleteModalFooter: {
    padding: '10px 22px 18px',
    borderTop: '1px solid #f1f5f9',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
  },
  btnCancelDelete: {
    padding: '8px 20px',
    borderRadius: '8px',
    border: '1.5px solid #e2e8f0',
    background: '#fff',
    color: '#6b7280',
    fontWeight: 600,
    fontSize: '0.875rem',
    cursor: 'pointer',
  },
  btnConfirmDelete: {
    padding: '8px 20px',
    borderRadius: '8px',
    border: 'none',
    background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
    color: '#fff',
    fontWeight: 700,
    fontSize: '0.875rem',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(220,38,38,0.3)',
  },
};

const RetailerRidersTable = () => {
    const dispatch = useDispatch();
    const { riders, loading } = useSelector((state) => state.riders);
    const user = getUserFromLocalStorage();
    const vendorId = user?.result?._id;
    const businessName = user?.result?.businessTradingName || user?.result?.businessName || 'Your Business';

    const [showRiderForm, setShowRiderForm] = useState(false);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [riderToDelete, setRiderToDelete] = useState(null);
    const [riderToEdit, setRiderToEdit] = useState(null);
    const [riderName, setRiderName] = useState('');

    useEffect(() => {
        if (vendorId) {
            dispatch(getRetailerRiders(vendorId));
        }

        const socket = io(process.env.REACT_APP_SERVER_URL);

        socket.on('connect', () => {
            console.log('Connected to server');
        });

        socket.on('riderStatusUpdate', (statusUpdate) => {
            dispatch({
                type: 'UPDATE_RETAILER_RIDER_STATUS',
                payload: statusUpdate
            });
        });

        socket.on('disconnect', () => {
            console.log('Disconnected from server');
        });

        return () => {
            socket.disconnect();
        };
    }, [dispatch, vendorId]);

    const handleDelete = () => {
        dispatch(deleteRetailerRider(vendorId, riderToDelete));
        setShowConfirmDialog(false);
    };

    const handleShowRiderForm = (rider = null) => {
        setRiderToEdit(rider);
        setShowRiderForm(true);
    };

    const handleCloseRiderForm = () => {
        setRiderToEdit(null);
        setShowRiderForm(false);
    };

    const confirmDelete = (riderId, name) => {
        setRiderToDelete(riderId);
        setRiderName(name);
        setShowConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setShowConfirmDialog(false);
        setRiderToDelete(null);
        setRiderName('');
    };

    const onlineCount  = riders.filter(r => r.onlineStatus === 'Online').length;
    const busyCount    = riders.filter(r => r.onlineStatus === 'Busy').length;
    const transitCount = riders.filter(r => r.onlineStatus === 'inTransit').length;
    const offlineCount = riders.filter(r => r.onlineStatus === 'Offline' || !r.onlineStatus).length;

    return (
        <div style={S.page}>

            {/* ── Page Header ── */}
            <div style={S.pageHeader}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <TwoWheeler style={{ color: 'rgba(255,255,255,0.85)', fontSize: '2rem' }} />
                    <div>
                        <div style={S.pageTitle}>{businessName} — Riders</div>
                        <div style={S.pageSubtitle}>{riders.length} rider{riders.length !== 1 ? 's' : ''} registered</div>
                    </div>
                </div>
                <button style={S.addBtn} onClick={() => handleShowRiderForm()}>
                    <Add style={{ fontSize: '1.1rem' }} /> Add Rider
                </button>
            </div>

            {/* ── Stat chips ── */}
            {!loading && riders.length > 0 && (
                <div style={S.statsRow}>
                    {[
                        { label: 'Online',     value: onlineCount,  Icon: SignalWifi4Bar, ...STATUS_CONFIG.Online },
                        { label: 'Busy',       value: busyCount,    Icon: Schedule,       ...STATUS_CONFIG.Busy },
                        { label: 'In Transit', value: transitCount, Icon: TwoWheeler,     ...STATUS_CONFIG.inTransit },
                        { label: 'Offline',    value: offlineCount, Icon: SignalWifiOff,  ...STATUS_CONFIG.Offline },
                    ].map(({ label, value, color, bg, Icon }) => (
                        <div key={label} style={S.statCard(color, bg)}>
                            <Icon style={{ color, fontSize: '1.3rem' }} />
                            <div>
                                <div style={S.statValue}>{value}</div>
                                <div style={S.statLabel}>{label}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* ── Table Card ── */}
            <div style={S.tableCard}>
                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '60px' }}>
                        <Spinner animation="border" style={{ color: '#0291a1' }} />
                    </div>
                ) : riders.length === 0 ? (
                    <div style={S.emptyState}>
                        <div style={S.emptyIcon}><TwoWheeler style={{ fontSize: '3rem', color: '#d1d5db' }} /></div>
                        <div style={S.emptyTitle}>No riders yet</div>
                        <div style={S.emptyText}>
                            Add your first in-house rider for {businessName} to get started with local deliveries.
                        </div>
                    </div>
                ) : (
                    <>
                        {/* Table header */}
                        <div style={S.tableHeader}>
                            {['#', 'Name', 'Mobile', 'Email', 'Vehicle', 'Status', 'Actions'].map(h => (
                                <div key={h} style={S.tableHeaderCell}>{h}</div>
                            ))}
                        </div>

                        {/* Rows */}
                        {riders.map((rider, index) => {
                            const cfg = getStatusCfg(rider.onlineStatus);
                            const CarrierIcon = CARRIER_ICON[rider.carrierType] || DirectionsCar;
                            return (
                                <div
                                    key={rider._id}
                                    style={S.tableRow(index % 2 === 1)}
                                >
                                    <div style={S.indexCell}>{index + 1}</div>
                                    <div style={S.nameCell}>{rider.firstName} {rider.lastName}</div>
                                    <div style={S.cell}>{rider.mobile}</div>
                                    <div style={{ ...S.cell, fontSize: '0.82rem', color: '#6b7280' }}>{rider.email}</div>
                                    <div>
                                        <span style={S.carrierBadge}>
                                            <CarrierIcon style={{ fontSize: '0.95rem' }} />
                                            {rider.carrierType}
                                        </span>
                                    </div>
                                    <div>
                                        <span style={S.statusBadge(cfg.color, cfg.bg)}>
                                            {cfg.label}
                                        </span>
                                    </div>
                                    <div style={S.actionCell}>
                                        <button
                                            style={S.btnEdit}
                                            onClick={() => handleShowRiderForm(rider)}
                                        >
                                            <Edit style={{ fontSize: '0.85rem' }} /> Edit
                                        </button>
                                        <button
                                            style={S.btnDelete}
                                            onClick={() => confirmDelete(rider._id, `${rider.firstName} ${rider.lastName}`)}
                                        >
                                            <Delete style={{ fontSize: '0.85rem' }} /> Delete
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </>
                )}
            </div>

            {/* ── Add / Edit Rider Modal ── */}
            <RetailerRiderForm
                show={showRiderForm}
                handleClose={handleCloseRiderForm}
                vendorId={vendorId}
                riderToEdit={riderToEdit}
            />

            {/* ── Delete Confirm Modal ── */}
            <Modal show={showConfirmDialog} onHide={handleCloseConfirmDialog} centered contentClassName="border-0">
                <div style={S.deleteModalContent}>
                    <div style={S.deleteModalHeader}>
                        <span style={{ ...S.deleteModalTitle, display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Delete style={{ fontSize: '1.1rem' }} /> Confirm Delete
                        </span>
                    </div>
                    <div style={S.deleteModalBody}>
                        Are you sure you want to remove <strong>{riderName}</strong> from your riders list? This action cannot be undone.
                    </div>
                    <div style={S.deleteModalFooter}>
                        <button style={S.btnCancelDelete} onClick={handleCloseConfirmDialog}>
                            Cancel
                        </button>
                        <button style={S.btnConfirmDelete} onClick={handleDelete}>
                            Yes, Delete
                        </button>
                    </div>
                </div>
            </Modal>

        </div>
    );
};

export default RetailerRidersTable;
